import { scoreColor } from "../lib/format";

export const DegenScore = ({ score, size = 56, showLabel = false }) => {
  const color = scoreColor(score);
  const r = (size - 6) / 2;
  const circ = 2 * Math.PI * r;
  const offset = circ - (score / 100) * circ;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="4" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth="4"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="butt"
          style={{ transition: "stroke-dashoffset 0.5s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono font-bold leading-none" style={{ color, fontSize: size * 0.32 }}>
          {score}
        </span>
        {showLabel && <span className="text-[9px] text-muted-foreground tracking-widest mt-0.5">SCORE</span>}
      </div>
    </div>
  );
};

const toneMap = {
  good: "text-neon bg-neon/10 border-neon/20",
  bad: "text-danger bg-danger/10 border-danger/20",
  warn: "text-warn bg-warn/10 border-warn/20",
};

export const FlagBadge = ({ flag }) => (
  <span
    className={`inline-flex items-center px-2 py-0.5 text-[11px] font-medium border ${toneMap[flag.tone] || toneMap.warn}`}
  >
    {flag.label}
  </span>
);

export const verdictColor = (verdict) => {
  switch (verdict) {
    case "High Confidence": return "#00E599";
    case "Moderate Confidence": return "#6EE7B7";
    case "Elevated Risk": return "#F5A623";
    case "High Risk": return "#FF3366";
    case "Insufficient Data": return "#8A8F98";
    default: return "#8A8F98";
  }
};

const momoTone = {
  good: "text-neon bg-neon/10 border-neon/30",
  bad: "text-danger bg-danger/10 border-danger/30",
  warn: "text-warn bg-warn/10 border-warn/30",
  neutral: "text-muted-foreground bg-white/5 border-white/10",
};

export const MomentumBadge = ({ momentum, showSpike = false }) => {
  if (!momentum) return null;
  return (
    <span
      title={`Volume ${momentum.spike}x hourly avg · ${momentum.concentration}% of 24h vol in last hour · ${momentum.buyRatioH1}% buys`}
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-[11px] font-medium border whitespace-nowrap ${momoTone[momentum.tone] || momoTone.neutral}`}
    >
      {momentum.label}
      {showSpike && momentum.spike >= 1.5 && <span className="font-mono opacity-70">{momentum.spike}x</span>}
    </span>
  );
};
